// extracted by mini-css-extract-plugin
export var label = "_hs-2";
export var slideContainer = "_hs-0";
export var slider = "_hs-1";